const salesReport = {
  statisticsByStatus: 'Статистика по статусу',
  statisticsByPayments: 'Статистика по платежам',
  from: 'от',
  till: 'до',
  myClients: 'Мои клиенты',
  newClients: 'Новые клиенты',
  showing: 'показывается',
  usersOf: 'пользователи',
  noUsersFound: 'пользователи не найдены',
  managerSuccessfullyChanged: 'Менеджер успешно изменен',
  lastPayments: 'Последние платежи',
  lastPaymentsOf: 'платежи',
  noSalesReportLastPaymentFound: 'Отчет о продажах, последний платеж не найден',
  pickReportRange: 'Выбрать диапазон отчета',
  pickUser: 'Выбрать пользователя',
  toolbar: {
    totalClients: 'Общее количество клиентов',
    activeClients: 'Активные клиенты',
    paymentsCommited: 'Платежи осуществлены',
    myPaymentsTotal: 'Общая сумма моих платежей',
  },
  actionDropdown: {
    changeStatus: 'Изменить статус',
    statusHistory: 'История статусов',
    editUser: 'Редактировать пользователя',
  },
  modal: {
    clientStatusAndNotes: 'Статус клиента и примечания',
    status: 'Статус',
    note: 'Примечание',
    statusChanged: 'Добавлено новое примечание или статус'
  }
};
export default salesReport;
